import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import Button from '@material-ui/core/Button';

import LOCALES from '../../../constants/locale/localeTypes';

import * as intlActions from '../../../actions/intlActions';

const LocaleButton = (props) => {
    return (
        <Button
            className="locale"
            onClick={() => props.intlActions.setLocale(props.intl.locale === LOCALES.EN ? LOCALES.FR : LOCALES.EN)}
            variant="outlined"
        >
            {(props.intl.locale === LOCALES.EN ? LOCALES.FR : LOCALES.EN).split('-')[0].toUpperCase()}
        </Button>
    );
};

function mapStateToProps(state) {
    return {
        intl: state.intl
    };
}

function mapDispatchToProps(dispatch) {
    return {
        intlActions: bindActionCreators(intlActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LocaleButton);


// WEBPACK FOOTER //
// ./src/components/common/button/LocaleButton.js